module.exports = __webpack_public_path__ + "static/images/star.3WiPnD1.svg";